import { useForm, Controller } from "react-hook-form";
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import Spinner from "../../Spinner/Spinner";
import { recaptchaKey } from '../../../constants/recaptchaKey';
import classes from './ContactForm.module.css';
import * as actions from '../../../store/actions';
import ContactFormMessage from "./ContactFormMessage/ContactFormMessage";

const ContactForm = (props) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm();

    const onSubmit = (data) => {
        props.sendMail(data);
    }
    
    return (
        <div className={classes.ContactForm}>
            <h3>{t('contact.form.title')}</h3>
            <ContactFormMessage error={props.error} sent={props.sent} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder={t('contact.form.name')}
                        className={errors && errors.name ? 'invalid' : ''}
                        {...register('name', { required: true })}  />
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        placeholder={t('contact.form.email')}
                        className={errors && errors.email ? 'invalid' : ''}
                        {...register('email', { required: true })} />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder={t('contact.form.subject')}
                        className={errors && errors.subject ? 'invalid' : ''}
                        {...register('subject', { required: true })} />
                </div>
                <div className="form-group">
                    <textarea
                        rows="4"
                        //defaultValue={t('contact.form.subject')}
                        placeholder={t('contact.form.message')}
                        className={errors && errors.message ? 'invalid' : ''}
                        {...register('message', { required: true })}></textarea>
                </div>
                <div className="form-group">
                    <div className={classes.RecaptchaContainer}>
                        <Controller
                            className={errors && errors.recaptcha ? 'invalid' : ''}
                            name="recaptcha"
                            control={control}
                            rules={{ required: "Please verify that you are human." }}
                            render={({ field }) => (
                                <ReCAPTCHA
                                    key={currentLanguage}
                                    hl={currentLanguage}
                                    className={classes.GRecaptcha}
                                    sitekey={recaptchaKey}
                                    onChange={(token) => field.onChange(token)}
                                />
                            )}
                        />
                    </div>
                    {
                        errors.recaptcha &&
                        <small className={classes.ErrorMessage}>
                            {t('contact.form.errorMessages.' + errors.recaptcha.message)}
                        </small>
                    }
                </div>
                {
                    props.loading
                        ? <Spinner />
                        : <button className="button primary-button">{t('contact.form.send')}</button>
                }

            </form>
        </div>
    );
};

const mapStateTpProps = (state) => {
    return {
        loading: state.mail.loading,
        error: state.mail.error,
        sent: state.mail.sent,
    };
};

const mapDisptactToProps = (dispatch) => {
    return {
        sendMail: (data) => dispatch(actions.sendMail(data)),
    };
};

export default connect(mapStateTpProps, mapDisptactToProps)(ContactForm);